/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Aria_DialogInputs */

const tr_mascot_chat_aria_dialog = /** @type {(inputs: Mascot_Chat_Aria_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel destek sohbeti`)
};

const en_mascot_chat_aria_dialog = /** @type {(inputs: Mascot_Chat_Aria_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel support chat`)
};

const de_mascot_chat_aria_dialog = /** @type {(inputs: Mascot_Chat_Aria_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ShopPanel Support-Chat`)
};

const ru_mascot_chat_aria_dialog = /** @type {(inputs: Mascot_Chat_Aria_DialogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Чат поддержки ShopPanel`)
};

/**
* | output |
* | --- |
* | "ShopPanel support chat" |
*
* @param {Mascot_Chat_Aria_DialogInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_aria_dialog = /** @type {((inputs?: Mascot_Chat_Aria_DialogInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Aria_DialogInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_aria_dialog(inputs)
	if (locale === "de") return de_mascot_chat_aria_dialog(inputs)
	if (locale === "ru") return ru_mascot_chat_aria_dialog(inputs)
	return tr_mascot_chat_aria_dialog(inputs)
});